import institutionIcons from '@/assets/images/institutions';
import { Box, Avatar, Typography, Button, DialogContent } from '@mui/material';
import { t } from 'i18next';
import { FinancialOptions } from '../useAddAccountNavigation';
import { IInstitution } from '../accountTypeData';

interface RecommendedAccountBeingAddedProps {
  selected: IInstitution | null;
  updateModalExperience: (experience: FinancialOptions) => void;
  onClose: () => void;
}

const RecommendedAccountBeingAdded = ({
  selected,
  updateModalExperience,
  onClose,
}: RecommendedAccountBeingAddedProps) => {
  return (
    <>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Avatar
            src={
              institutionIcons[selected?.value as keyof typeof institutionIcons]
            }
            sx={{ width: 48, height: 48 }}
          >
            {selected?.label.charAt(0)}
          </Avatar>

          <Typography variant='h6'>
            {t('addAccountModal.accountBeingAdded')}
          </Typography>

          <Box textAlign='center'>
            <Typography variant='body2'>
              {t('addAccountModal.accountReadyNotification', {
                institutionName: selected?.label,
              })}
            </Typography>
            <Typography variant='body2'>
              {t('addAccountModal.nextSteps')}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      {/* Footer */}
      <Box
        sx={{
          borderTop: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
          padding: 3,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button
            variant='outlined'
            type='button'
            onClick={() => updateModalExperience(FinancialOptions.ADD_ACCOUNT)}
          >
            {t('addAccountModal.footer.addAnother')}
          </Button>
          <Button
            variant='contained'
            type='button'
            onClick={onClose}
          >
            {t('addAccountModal.footer.done')}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RecommendedAccountBeingAdded;
